import React, { useState } from 'react';

import AdditionalFieldsInfoScreen from 'apps/auth/components/profile/AdditionalFieldsInfoScreen';
import AdditionalFieldsScreen from 'apps/auth/components/profile/AdditionalFieldsScreen';
import BasePage from 'apps/auth/components/utils/BasePage';
import { FIELDS_SCREEN, INFO_SCREEN } from 'apps/auth/constants/Constants';
import { useExtra } from 'apps/auth/hooks/selectors';

const ProfileAdditionalFieldsPage = () => {
    const { residenceAddressMustBeUpdated } = useExtra();

    const [screen, setScreen] = useState(residenceAddressMustBeUpdated ? FIELDS_SCREEN : INFO_SCREEN);

    if (screen === INFO_SCREEN) {
        return <AdditionalFieldsInfoScreen setScreen={setScreen} />;
    } else if (screen === FIELDS_SCREEN) {
        return <AdditionalFieldsScreen setScreen={setScreen} />;
    }
};

export default BasePage(ProfileAdditionalFieldsPage);
